<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput :options="titleInput.options" :data="titleInput.data"/>
                </CCol>
                <CCol xs="12" sm="6" md="6" lg="6" xl="6">
                  <BaseSelect :options="typeSelect.options" :data="typeSelect.data" ref="typeSelect"></BaseSelect>
                </CCol>
                <CCol sm="6" md="6" xl="6"
                      v-if="typeSelect.data.model == 1 || typeSelect.data.model == 2|| typeSelect.data.model == 4|| typeSelect.data.model == 5">
                  <div class="form-input-wrapper">
                    <div class="form-group">
                      <label class="form-label" for="uploadFile">Chọn bản tin<span class='required'> *</span></label>
                      <div class="custom-file"
                           :class="selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                        <input type="file" class="custom-file-input" id="uploadFile" ref="file"
                               :accept="acceptFile" @change="selectFile($event)">
                        <label class="custom-file-label" for="uploadFile">{{ fileName }}
                          <i v-if="selectedFiles.data.loading" class="fa fa-spinner fa-spin"
                             style="position: absolute; right: 100px;font-size: 20px;top: 8px;"></i>
                        </label>
                      </div>
                      <div class="valid-error"
                           v-show="!(selectedFiles.data.validator ? selectedFiles.data.validator.isValid : true)">
                        {{ selectedFiles.data.validator ? selectedFiles.data.validator.errorMessage : "" }}
                      </div>
                    </div>
                  </div>
                </CCol>
                <!-- <CCol xs="12" sm="6" md="6" lg="6" xl="6">
                  <BaseSelect :options="levelSelect.options" :data="levelSelect.data" ref="levelSelect"></BaseSelect>
                </CCol> -->
                <!-- <CCol xs="12" sm="6" md="6" lg="6" xl="6">
                  <BaseSelect :options="departmentsInput.options" :data="departmentsInput.data"
                              ref="departmentsInput"></BaseSelect>
                </CCol> -->

                <CCol sm="6" md="6" xl="6" v-if="typeSelect.data.model == 3 || typeSelect.data.model == 5">
                  <BaseInput :options="rssOrVtvInput.options" :data="rssOrVtvInput.data"/>
                </CCol>
                <CCol xs="12" sm="12" md="6" xl="6" v-if="typeSelect.data.model == 0">
                  <div class="form-group">
                    <label for="datepicker">Chữ chạy
                      <span class="required">*</span></label>
                    <br/>
                    <CInputCheckbox custom :checked="isTextRun.data.model" @update:checked="changeIsRun($event)"
                                    addInputClasses="override-custom"></CInputCheckbox>
                  </div>
                </CCol>
                <CCol xs="12" sm="12" md="6" xl="6"
                      v-if="(typeSelect.data.model == 0 && !isTextRun.data.model) || typeSelect.data.model == 1|| typeSelect.data.model == 4">
                  <div class="form-group">
                    <label for="datepicker">Thời lượng phát
                      <span class="required">*</span></label>
                    <br/>
                    <VueTimepicker v-model="durationData" format="HH:mm:ss" :hide-clear-button="true"
                                   :second-range="validRangeTime"
                                   input-class="form-control col-xs-12 col-sm-12 col-md-12 col-xl-12"
                                   placeholder="Thời lượng phát" hour-label="Giờ" minute-label="Phút"
                                   second-label="Giây">
                    </VueTimepicker>
                    <div class="valid-error"
                         v-show="!(durationInput.data.validator ? durationInput.data.validator.isValid : true)">
                      {{ durationInput.data.validator ? durationInput.data.validator.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <CCol sm="12" md="12" xl="12" v-if="typeSelect.data.model == 0">
                  <BaseTextArea :options="contentInput.options" :data="contentInput.data"
                                v-model="contentInput.data.model"/>
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <BaseTextArea :options="descriptionInput.options" :data="descriptionInput.data"
                                v-model="descriptionInput.data.model"/>
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton
                  color="primary"
                  class="btn-action-primary mr-2"
                  @click="submitData(false)">
                  <i class="fa fa-plus"></i> Lưu lại
                </CButton>
                <CButton
                  color="secondary"
                  class="btn-action-primary"
                  @click="$router.go(-1)"><i class="fa fa-reply"></i> Hủy bỏ
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseLoading from "@/views/base/BaseFormLoading";
import BaseTextArea from "@/views/base/BaseTextArea";
import {LOCATION_CODE_NAME} from "@/constant";

export default {
  name: "ScreenFileAdd",
  components: {BaseSelect, BaseInput, BaseLoading, BaseTextArea, VueTimepicker},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      durationData: {
        HH: '00',
        mm: '00',
        ss: '30'
      },
      validRangeTime: [[30, 59]],
      fileName: 'Chọn tệp',
      acceptFile: ".mp4",
      titleInput: {
        options: {
          label: "Tiêu đề bản tin <span class='required'>*</span>",
          placeholder: "Tiêu đề bản tin",
          maxlength: 200
        },
        data: {
          name: "title",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tiêu đề bản tin không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      durationInput: {
        data: {
          name: "duration",
          model: null,
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let type = that.typeSelect.data.model;
              if (((type == 0 && that.isTextRun.data.model == false) || type == 1 || type == 4) && !(that.durationData.HH == "" && that.durationData.mm == "" && that.durationData.ss == "")) {
                let duration = "";
                if (that.durationData.HH == "") {
                  duration = "00"
                } else {
                  duration = that.durationData.HH
                }

                if (that.durationData.mm == "") {
                  duration += ":00"
                } else {
                  duration += ":" + that.durationData.mm
                }

                if (that.durationData.ss == "") {
                  duration += ":00"
                } else {
                  duration += ":" + that.durationData.ss
                }

                that.durationInput.data.model = duration;
              }
              let value = that.durationInput.data.model;
              if ((value == "" || value == null) && ((type == 0 && that.isTextRun.data.model == false) || type == 1 || type == 4)) {
                this.isValid = false;
                this.errorMessage = "Thời lượng phát không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      descriptionInput: {
        options: {
          label: "Mô tả bản tin",
          placeholder: "Mô tả bản tin",
          maxlength: 2000,
          rows: 5
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          }
        }
      },
      contentInput: {
        options: {
          label: "Nội dung bản tin",
          placeholder: "Nội dung bản tin",
          rows: 5
        },
        data: {
          name: "content",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.contentInput.data.model;
              let type = that.typeSelect.data.model;
              if (value == "" && type == 0) {
                this.isValid = false;
                this.errorMessage = "Nội dung bản tin không được để trống";
              } else {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      typeSelect: {
        options: {
          filter: false,
          label: 'Loại bản tin',
        },
        data: {
          name: "type",
          items: [
            {key: "0", value: "Văn bản"},
            {key: "1", value: "Hình ảnh"},
            {key: "2", value: "Video"},
            {key: "3", value: "RSS"},
            {key: "4", value: "Tài liệu"},
          ],
          model: "2",
          updateCallback: function () {
            that.submitData();
          },
        }
      },
      selectedFiles: {
        data: {
          loading: false,
          name: "file",
          model: {
            fileName: '',
            content: '',
            size: '',
            type: ''
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              this.isValid = that.validateFile();
              return this.isValid;
            }
          }
        }
      },
      fileThumbnail: {
        data: {
          name: "fileThumbnail",
          model: {
            fileName: '',
            content: ''
          },
        }
      },
      userName: {
        data: {
          name: "userName",
          model: localStorage.getItem("userName")
        }
      },
      isTextRun: {
        data: {
          name: "isRun",
          model: true
        }
      },
      rssOrVtvInput: {
        options: {
          placeholder: 'Đường dẫn RSS',
          label: 'Đường dẫn RSS'
        },
        data: {
          name: "rss",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.rssOrVtvInput.data.model;
              let type = that.typeSelect.data.model;
              if (type == 3 || type == 5) {
                let regex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
                if (value === "") {
                  this.isValid = false;
                  this.errorMessage = type == 3 ? "Đường dẫn RSS không được để trống" : "Đường dẫn kênh trực tuyến không được để trống";
                } else if (regex.test(value) == false) {
                  this.isValid = false;
                  this.errorMessage = type == 3 ? "Sai định dạng đường dẫn RSS" : "Sai định dạng đường dẫn kênh trực tuyến";
                } else {
                  this.isValid = true;
                }
              }
              return this.isValid;
            }
          }
        },
      },
    }
  },
  methods: {
    generateImageThumbnail(file, boundBox) {
      if (!boundBox || boundBox.length != 2) {
        throw "You need to give the boundBox"
      }

      var reader = new FileReader();
      var canvas = document.createElement("canvas")
      var ctx = canvas.getContext('2d');

      return new Promise((resolve) => {
        reader.onload = function (event) {
          var img = new Image();
          img.onload = function () {
            var scaleRatio = Math.min(...boundBox) / Math.max(img.width, img.height)
            let w = img.width * scaleRatio
            let h = img.height * scaleRatio
            canvas.width = w;
            canvas.height = h;
            ctx.drawImage(img, 0, 0, w, h);
            return resolve(canvas.toDataURL(file.type))
          }
          img.src = event.target.result;
        }
        reader.readAsDataURL(file);
      })
    },
    generateVideoThumbnail(file, boundBox) {
      return new Promise((resolve) => {
        const canvas = document.createElement("canvas");
        const video = document.createElement("video");

        // this is important
        video.autoplay = true;
        video.muted = true;
        video.src = URL.createObjectURL(file);
        video.currentTime = 10;

        video.onloadeddata = () => {
          let ctx = canvas.getContext("2d");

          var scaleRatio = Math.min(...boundBox) / Math.max(video.videoWidth, video.videoHeight)
          let w = video.videoWidth * scaleRatio
          let h = video.videoHeight * scaleRatio
          canvas.width = w;
          canvas.height = h;

          ctx.drawImage(video, 0, 0, w, h);
          video.pause();
          return resolve(canvas.toDataURL("image/png"));
        };
      });
    },
    changeIsRun: function (value) {
      this.isTextRun.data.model = value;
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= this.titleInput.data.validator.valid();
      isValid &= this.selectedFiles.data.validator.valid();
      isValid &= this.contentInput.data.validator.valid();
      isValid &= this.durationInput.data.validator.valid();
      isValid &= this.rssOrVtvInput.data.validator.valid();
      if (!isValid) {
        return;
      }

      that.loading.value = true;
      let formData = new FormData();
      formData.append("title", that.titleInput.data.model);
      formData.append("description", that.descriptionInput.data.model);
      formData.append("userName", that.userName.data.model);
      formData.append("userLocationCode", localStorage.getItem(LOCATION_CODE_NAME));
      formData.append("type", that.typeSelect.data.model);
      formData.append("content", that.contentInput.data.model);
      formData.append("isRun", that.isTextRun.data.model);
      if (that.typeSelect.data.model == 0 && that.isTextRun.data.model == false) {
        formData.append("duration", that.durationInput.data.model);
      } else if (that.typeSelect.data.model == 3 || that.typeSelect.data.model == 5) {
        formData.append("url", that.rssOrVtvInput.data.model);
      }
      if (that.typeSelect.data.model == 1 || that.typeSelect.data.model == 2 || that.typeSelect.data.model == 4 || that.typeSelect.data.model == 5) {
        formData.append("file", that.$refs.file.files[0]);
        if (that.typeSelect.data.model != 5) {
          formData.append("duration", that.durationInput.data.model);
        }
        formData.append("fileNameThumbnail", that.fileThumbnail.data.model.fileName);
        formData.append("contentThumbnail", that.fileThumbnail.data.model.content);
      }

      that.$helper.loadDataSource({
        url: "/screen-file/addFile",
        dataSubmit: function () {
          return formData;
        },
        isMultiPartFormData: true,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({message: "Thêm mới bản tin thành công"});
            that.$router.push('/files-screen-management/managed-files.html')
          }
          that.loading.value = false
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },
    selectFile() {
      let that = this;
      let reader = new FileReader();
      let file = this.$refs.file;
      if (file && file.files[0]) {
        file = file.files[0];
        this.selectedFiles.data.loading = true;
        if (this.typeSelect.data.model == 1 || this.typeSelect.data.model == 2) {
          var video = document.createElement('video');
          video.preload = 'metadata';
          video.onloadedmetadata = function () {
            window.URL.revokeObjectURL(video.src);
            that.durationInput.data.model = (new Date(video.duration * 1000).toISOString().substr(11, 8));
          }
          video.src = URL.createObjectURL(file);
        }

        reader.readAsDataURL(file);
        reader.onload = function () {
          that.fileName = file.name;
          let isValid = that.validateFile(file.type, file.size);
          // if (isValid) {
          that.selectedFiles.data.model.size = file.size;
          that.selectedFiles.data.model.fileName = file.name;
          that.selectedFiles.data.model.type = file.type;
          // that.selectedFiles.data.model.content = reader.result.split(',')[1];
          // }
        }
        reader.onloadend = function () {
          that.selectedFiles.data.loading = false;
        }

        // if (that.typeSelect.data.model == 1) {
        //   that.generateImageThumbnail(file, [1280, 720]).then(function (dataUrl) {
        //     that.fileThumbnail.data.model.fileName = file.name.split('.')[0] + "_" + "thumbnail" + "." + file.name.split('.')[1];
        //     that.fileThumbnail.data.model.content = dataUrl.split(',')[1];
        //   })
        // } else if (that.typeSelect.data.model == 2) {
        //   that.generateVideoThumbnail(file, [1280, 720]).then(function (dataUrl) {
        //     that.fileThumbnail.data.model.fileName = file.name.split('.')[0] + "_" + "thumbnail" + ".png";
        //     that.fileThumbnail.data.model.content = dataUrl.split(',')[1];
        //   })
        // }
      }
    },
    validateFile(type, size) {
      let fileType = this.typeSelect.data.model;
      let isValid = true;
      if ((type && type != undefined) && (size && size != undefined)) {
        isValid = this.validateFileType(type, size);
      } else {
        if (fileType == 1 || fileType == 2 || fileType == 4 || fileType == 5) {
          if (this.selectedFiles.data.model.type && this.selectedFiles.data.model.size) {
            isValid = this.validateFileType(this.selectedFiles.data.model.type, this.selectedFiles.data.model.size);
          } else {
            if (this.selectedFiles.data.model.fileName === '') {
              this.selectedFiles.data.validator.isValid = false;
              this.selectedFiles.data.validator.errorMessage = "Nội dung bản tin không để trống";
              isValid = false;
            }
          }
        }
      }
      return isValid;
    },
    validateFileType(type, size) {
      let isValid = true;
      let fileType = this.typeSelect.data.model;
      if (size > 157286400) {
        this.selectedFiles.data.validator.isValid = false;
        this.selectedFiles.data.validator.errorMessage = "Tệp tin không được quá 150MB";
        isValid = false;
      } else if ((fileType == 1 || fileType == 5) && (type === "image/jpeg" || type === "image/png")) {
        this.selectedFiles.data.validator.isValid = true;
        this.selectedFiles.data.validator.errorMessage = "";
      } else if (fileType == 2 && (type === "video/mp4")) {
        this.selectedFiles.data.validator.isValid = true;
        this.selectedFiles.data.validator.errorMessage = "";
      } else if (fileType == 4 && (type === "application/pdf" || type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        || type === "application/msword")) {
        this.selectedFiles.data.validator.isValid = true;
        this.selectedFiles.data.validator.errorMessage = "";
      } else {
        this.selectedFiles.data.validator.isValid = false;
        this.selectedFiles.data.validator.errorMessage = "Sai định dạng bản tin";
        isValid = false;
      }
      return isValid;
    }
  },
  computed: {},
  created() {
  },
  mounted() {
    if (this.$hasAuthor('ROLE_ADMIN')) {
      this.typeSelect.data.items.push({key: 5, value: 'Kênh trực tuyến'})
    }
  },
  watch: {
    'typeSelect.data.model': function (value) {
      if (value == 0 && !this.isTextRun.data.model) {
        this.durationData = {
          HH: '00',
          mm: '00',
          ss: '30'
        }
      } else if (value == 1) {
        // this.acceptFile = "image/*";
        this.acceptFile = '.jpg,.png';
        this.durationData = {
          HH: '00',
          mm: '00',
          ss: '30'
        }
      } else if (value == 2) {
        this.acceptFile = ".mp4";
      } else if (value == 3) {
        this.rssOrVtvInput.options.label = "Đường dẫn kênh RSS";
        this.rssOrVtvInput.options.placeholder = "Đường dẫn kênh RSS";
        if (!this.rssOrVtvInput.data.validator.isValid) {
          this.rssOrVtvInput.data.validator.valid();
        }
      } else if (value == 4) {
        this.acceptFile = ".doc,.docx,.pdf";
        this.durationData = {
          HH: '00',
          mm: '00',
          ss: '10'
        }
        this.validRangeTime = [[10, 59]];
      } else if (value == 5) {
        this.acceptFile = '.jpg,.png';
        this.rssOrVtvInput.options.label = "Đường dẫn kênh trực tuyến";
        this.rssOrVtvInput.options.placeholder = "Đường dẫn kênh trực tuyến";
        if (!this.rssOrVtvInput.data.validator.isValid) {
          this.rssOrVtvInput.data.validator.valid();
        }
      }
      this.selectedFiles.data.model.content = '';
      this.selectedFiles.data.model.fileName = '';
      this.selectedFiles.data.model.type = '';
      this.selectedFiles.data.model.size = '';
      this.fileName = 'Chọn tệp';
    },
    'isTextRun.data.model': function () {
      this.durationData = {
        HH: '00',
        mm: '00',
        ss: '30'
      }
    },
    'durationData': function (value) {
      if (value.HH !== '00' || value.mm !== '00') {
        this.validRangeTime = [[0, 59]];
      } else {
        if (this.typeSelect.data.model == 4) {
          this.validRangeTime = [[10, 59]];
        } else {
          this.validRangeTime = [[30, 59]];
        }
      }
    }
  }
};
</script>
<style>
.vc-date {
  display: none !important;
}

.vue__time-picker, .vue__time-picker input.display-time {
  width: 100% !important;
}

.vue__time-picker .dropdown, .vue__time-picker-dropdown, .vue__time-picker .dropdown .select-list, .vue__time-picker-dropdown .select-list {
  width: 20em !important;
  height: 15em !important;
}

.vue__time-picker .dropdown .hint, .vue__time-picker-dropdown .hint {
  font-size: 18px !important;
}


</style>
